import * as Sentry from "@sentry/angular";
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'hammerjs';

Sentry.init({
    dsn: null, //environment.production ? "https://ac6f0b26fe5ef3f66265dc6f5577273e@o4510035615416320.ingest.de.sentry.io/4510061988282448" : null,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    enableLogs: true,
    environment: environment.production ? 'production' : 'development',
    release: 'ciceroneweb@1.0.0',
})

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));